// extracted by mini-css-extract-plugin
export default {"iconBox":"cnmlDXp7_F_wOk2JeL6v","small":"R7iQVhaYf99ae79kqrqB","large":"UNB3fI2pz9YbKWw2jf65"};